import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="expandable-row"
export default class extends Controller {
  static targets = ["details"]

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    // Toggle the details visibility
    this.detailsTarget.classList.toggle("hidden")

    // Keep disclosure indicators as icons; only their state changes.
    const indicators = this.element.querySelectorAll(".expandable-row-indicator")
    const isExpanded = !this.detailsTarget.classList.contains("hidden")

    indicators.forEach(indicator => {
      indicator.classList.toggle("rotate-180", isExpanded)
    })
  }
}
